export const usersKeys = {
  all: ["users"] as const,
  details: () => [...usersKeys.all, "detail"] as const,
  detail: (email: string | undefined) =>
    [...usersKeys.details(), email] as const,
  token: (token: string | undefined) =>
    [...usersKeys.details(), token] as const,
  slackUsernames: () =>
    [...usersKeys.all, "slackUsernames"] as const,
}
